import { render, staticRenderFns } from "./DiagramsToCompare.vue?vue&type=template&id=52263c84&scoped=true&"
import script from "./DiagramsToCompare.vue?vue&type=script&lang=ts&"
export * from "./DiagramsToCompare.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramsToCompare.vue?vue&type=style&index=0&id=52263c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52263c84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VDivider,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSpacer})
